export default "__VITE_ASSET__DCIOcCFH__"